import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { ISO_UTC_OFFSET_FORMAT } from '../constants/global.constants';

dayjs.extend(utc);

export const toISOUTCWithOffset = (
  dateValue: Dayjs | Date | string
): string => {
  if (!dateValue) {
    return '';
  }

  const dateDayjs = dayjs(dateValue);
  return dateDayjs.utc().format(ISO_UTC_OFFSET_FORMAT);
};
